//shreeapp/src/hooks/useEsewaPayment.js
import { useState } from "react";
import axios from "axios";
import { v4 as uuidv4 } from "uuid";

const useEsewaPayment = () => {
  const [loading, setLoading] = useState(false);

 const initiatePayment = async ({ amount, transaction_uuid }) => {
  setLoading(true);
  const transactionId = transaction_uuid; // Use the same ID from handlePurchase

  try {
    const res = await axios.post("http://localhost:5000/api/esewa/generate-signature", {
      total_amount: amount,
      transaction_uuid: transactionId,
      product_code: "EPAYTEST",
    });

    const { signature } = res.data;

    const form = document.createElement("form");
    form.method = "POST";
    form.action = "https://rc-epay.esewa.com.np/api/epay/main/v2/form";

    const formFields = {
      amount,
      tax_amount: 0,
      total_amount: amount,
      transaction_uuid: transactionId,
      product_code: "EPAYTEST",
      product_service_charge: 0,
      product_delivery_charge: 0,
      success_url: "http://localhost:3000/payment-success",
      failure_url: "http://localhost:3000/payment-failure",
      signed_field_names: "total_amount,transaction_uuid,product_code",
      signature,
    };

    Object.entries(formFields).forEach(([name, value]) => {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = name;
      input.value = value;
      form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();
  } catch (error) {
    console.error("eSewa Payment Error:", error);
  } finally {
    setLoading(false);
  }
};


  return { initiatePayment, loading };
};

export default useEsewaPayment;
